import Deposit from './deposit';
import {register, unregister} from './serviceWorker';
import web3 from './web3';

export { Deposit, register, unregister, web3};
